export default __webpack_public_path__ + "media/images/3-dogs-spaced-c0b49297b3e1b0ce0dfa3b41320074db.png";